import React from 'react';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  type?: string;
  icon?: string;
  iconColor?: string;
  rounded?: number;
  border?: number;
  error?: string;
  tooltip?: string;
}

export const MLInput: React.FC<Props> = ({
  label = 'title',
  type = 'text',
  error,
  placeholder,
  icon,
  border,
  rounded,
  size,
  iconColor = 'muted',
  tooltip,
  ...props
}) => {
  const inputClassName = `form-control ${error ? 'is-invalid border-danger' : ''} ${size ? `form-control-${size}` : ''} ${border ? `border-${border}` : ''} ${rounded ? `rounded-${rounded} ` : ''}`;

  return (
    <div>
      <label htmlFor="basiInput" className={`form-label ${error ? 'text-danger' : ''}  mb-1`} title={tooltip}>
        {label}
        {props.required && <span className="text-danger m-1">*</span>}
      </label>
      {icon ? (
        <div className="form-icon right">
          <input
            type={type}
            className={`${inputClassName}} form-control-icon `}
            id="basiInput"
            placeholder={placeholder}
            {...props}
          />
          <i className={`${icon} text-${iconColor}`} />
        </div>
      ) : (
        <>
          <input type={type} className={inputClassName} id="basiInput" placeholder={placeholder} {...props} />
          {error && <div className="text-danger w-100 d-block mt-1 ">{error}</div>}
        </>
      )}
    </div>
  );
};
